function storage() {
  const getData = (propKey: string) => {
    return data[propKey];
  };

  const setData = (propKey: string, value: any) => {
    data[propKey] = value;
  };

  return [getData, setData] as const;
}
const data: Record<string, any> = {};

const [getData, setData] = storage();

export { getData, setData };
